import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import u from "classnames";
import t from "./index.es771.js";
import { GoogleIcon as p } from "./index.es436.js";
const c = "google-button", h = f(
  ({
    size: r = "default",
    fullWidth: s = !1,
    onClick: n,
    label: o = "Sign in with Google",
    testId: i = c,
    ...l
  }, a) => /* @__PURE__ */ m(
    "button",
    {
      "data-testid": i,
      type: "button",
      onClick: n,
      ref: a,
      className: u(t.button, [t[`button--size-${r}`]], {
        [t["button--full-width"]]: s
      }),
      "aria-label": o,
      ...l,
      children: [
        /* @__PURE__ */ e(p, { size: 16 }),
        /* @__PURE__ */ e("span", { children: o })
      ]
    }
  )
);
export {
  c as GOOGLE_BUTTON_DEFAULT_TEST_ID,
  h as GoogleButton
};
//# sourceMappingURL=index.es14.js.map
